import { Form } from 'antd'
import { colors } from '../../../../services/style'
import { CustomSwitch } from '../../../monitor/components/CustomSwitch'
import { useState } from 'react'

export const Option = ({ title, description, onChange, checked, formName }) => {
    const [isChecked, setIsChecked] = useState(false)

    const handleToggleCheck = (event, newCheck) => {
        setIsChecked(newCheck)
        onChange(newCheck)
    }

    return (
        <div
            className="rounded-[8px] settings-modal-configs-notifications-option flex justify-between bg-sl-transparency-16 items-center"
            style={{ border: `1.5px solid ${colors['sl-transparency'][8]}` }}
        >
            <div className="flex flex-col gap-1">
                <span className="settings-modal-configs-notifications-option-title">{title}</span>
                <span className="settings-modal-configs-notifications-option-description">{description}</span>
            </div>
            {formName ? (
                <Form.Item name={formName} className="mb-0">
                    <CustomSwitch checked={isChecked} onChange={handleToggleCheck} defaultChecked={checked} id="option" sx={{ m: '0.3rem' }} />
                </Form.Item>
            ) : (
                <CustomSwitch checked={isChecked} onChange={handleToggleCheck} defaultChecked={checked} id="option" sx={{ m: '0.3rem' }} />
            )}
        </div>
    )
}
